import { Ban, CheckCircle2, Loader2, XCircle } from 'lucide-react'

import { XeroConnectionSyncStatus } from '@ankor-io/common/types/integrations/xero/types'
import { Badge } from '@ankor-io/ui-components'

export function statusBadge(status: string) {
  switch (status) {
    case XeroConnectionSyncStatus.COMPLETED:
      return <Badge color="green">Completed</Badge>
    case XeroConnectionSyncStatus.FAILED:
      return <Badge color="red">Failed</Badge>
    case XeroConnectionSyncStatus.IN_PROGRESS:
      return <Badge color="yellow">Running</Badge>
    default:
      return <Badge color="gray">{status}</Badge>
  }
}

export function stepStatusIcon(status: string) {
  switch (status) {
    case 'COMPLETED':
      return <CheckCircle2 className="size-4 text-green-500 shrink-0" />
    case 'FAILED':
      return <XCircle className="size-4 text-red-500 shrink-0" />
    case 'IN_PROGRESS':
      return <Loader2 className="size-4 text-yellow-500 animate-spin shrink-0" />
    default:
      return <Ban className="size-4 text-gray-400 shrink-0" />
  }
}
